import axios from "axios";
import { getAppConfiguration } from "appConfig";

export interface QueueGalleryAiPhotoRequest {
  reservationId: string;
  sessionId: string;
  photoId: string;
  filterId: string;
  aiPremium: boolean;
  includeVideo?: boolean;
}

export interface QueueGalleryAiPhotoResponse {
  success: boolean;
  queuedPhotoId: string | null;
  destinationReservationId: string | null;
  errorMessage: string | null;
}

export async function queueGalleryAiPhoto(
  request: QueueGalleryAiPhotoRequest
): Promise<QueueGalleryAiPhotoResponse> {
  console.log("queueGalleryAiPhoto - calling API with:", request);
  const appConfiguration = await getAppConfiguration();
  const url = `${appConfiguration.apiUrl}/api/Media/queueGalleryAiPhoto`;
  
  // Direct axios call without waiting for session (endpoint is AllowAnonymous)
  const response = await axios.post(url, request, {
    headers: { "Content-Type": "application/json" }
  });
  
  console.log("queueGalleryAiPhoto - response:", response);
  return response.data;
}